// extracted by mini-css-extract-plugin
export default {"card":"components-general-account-selection-card-module__card"};